/**
 * Organization contacts config (KAN-742)
 *
 * Mirrors the backend registry ai_agent/prompt/contacts.py::CONTACT_FIELDS
 * (same order, same labels). Used by the "Контакты" block and to label
 * validation errors of the organization save.
 */
import type { OrganizationContactField } from '@/types/settings';

export interface ContactInput {
  field: OrganizationContactField;
  label: string;
  placeholder: string;
  type?: string;
}

export const CONTACT_INPUTS: ContactInput[] = [
  { field: 'website', label: 'Сайт', placeholder: 'example.ru' },
  { field: 'phone', label: 'Телефон', placeholder: '+7 495 123-45-67', type: 'tel' },
  { field: 'company_email', label: 'Email', placeholder: 'info@example.ru', type: 'email' },
  { field: 'telegram', label: 'Telegram', placeholder: '@company или https://t.me/company' },
  { field: 'max_contact', label: 'MAX', placeholder: 'Ник, ссылка или телефон в MAX' },
  { field: 'whatsapp', label: 'WhatsApp', placeholder: '+79991234567' },
];

export const CONTACTS_HINT = 'Контакты попадают в промпт бота, он называет их по запросу клиента.';

/** Labels of the organization settings fields, for validation error messages. */
export const ORGANIZATION_FIELD_LABELS: Record<string, string> = {
  name: 'Название организации',
  company_name: 'Название компании',
  company_description: 'Описание компании',
  ecommerce_settings: 'Модуль интернет-магазин',
  lead_attributes: 'Атрибуты лида',
  ...Object.fromEntries(CONTACT_INPUTS.map(({ field, label }) => [field, label])),
};
